/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * B2B Backend API
 * API documentation for B2B Platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  PublicReadinessQuestion,
  ReadinessAssessment,
  ReadinessSubmitRequest
} from '.././model'
import { customInstance } from '../../../../api/client';



/**
 * List the active questions a company needs to answer. Options' points are hidden — only moderators see the scoring.
 * @summary List active readiness questions
 */
export const readinessQuestionsList = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<PublicReadinessQuestion[]>(
      {url: `/api/v1/readiness/questions/`, method: 'GET', signal
    },
      );
    }
  

export const getReadinessQuestionsListQueryKey = () => {
    return [`/api/v1/readiness/questions/`] as const;
    }

    
export const getReadinessQuestionsListQueryOptions = <TData = Awaited<ReturnType<typeof readinessQuestionsList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readinessQuestionsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReadinessQuestionsListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof readinessQuestionsList>>> = ({ signal }) => readinessQuestionsList(signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 600000, refetchOnMount: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof readinessQuestionsList>>, TError, TData> & { queryKey: QueryKey }
}

export type ReadinessQuestionsListQueryResult = NonNullable<Awaited<ReturnType<typeof readinessQuestionsList>>>
export type ReadinessQuestionsListQueryError = unknown

/**
 * @summary List active readiness questions
 */
export const useReadinessQuestionsList = <TData = Awaited<ReturnType<typeof readinessQuestionsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readinessQuestionsList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getReadinessQuestionsListQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * The company's latest assessment plus `gateActive`, which is `true` when there are active questions (otherwise the gate is off and the readiness check is skipped entirely).
 * @summary My company's readiness status
 */
export const readinessStatusRetrieve = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/readiness/status/`, method: 'GET', signal
    },
      );
    }
  

export const getReadinessStatusRetrieveQueryKey = () => {
    return [`/api/v1/readiness/status/`] as const;
    }

    
export const getReadinessStatusRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof readinessStatusRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readinessStatusRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReadinessStatusRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof readinessStatusRetrieve>>> = ({ signal }) => readinessStatusRetrieve(signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 600000, refetchOnMount: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof readinessStatusRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ReadinessStatusRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof readinessStatusRetrieve>>>
export type ReadinessStatusRetrieveQueryError = unknown

/**
 * @summary My company's readiness status
 */
export const useReadinessStatusRetrieve = <TData = Awaited<ReturnType<typeof readinessStatusRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readinessStatusRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getReadinessStatusRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Submit the company's answers. Returns the computed score, band and whether it clears the gate. Every submission is kept — the latest one is the current state.
 * @summary Submit a readiness assessment
 */
export const readinessSubmitCreate = (
    readinessSubmitRequest: ReadinessSubmitRequest,
 ) => {
      
      
      return customInstance<ReadinessAssessment>(
      {url: `/api/v1/readiness/submit/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: readinessSubmitRequest
    },
      );
    }
  


export const getReadinessSubmitCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof readinessSubmitCreate>>, TError,{data: ReadinessSubmitRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof readinessSubmitCreate>>, TError,{data: ReadinessSubmitRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof readinessSubmitCreate>>, {data: ReadinessSubmitRequest}> = (props) => {
          const {data} = props ?? {};

          return  readinessSubmitCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReadinessSubmitCreateMutationResult = NonNullable<Awaited<ReturnType<typeof readinessSubmitCreate>>>
    export type ReadinessSubmitCreateMutationBody = ReadinessSubmitRequest
    export type ReadinessSubmitCreateMutationError = void

    /**
 * @summary Submit a readiness assessment
 */
export const useReadinessSubmitCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof readinessSubmitCreate>>, TError,{data: ReadinessSubmitRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof readinessSubmitCreate>>,
        TError,
        {data: ReadinessSubmitRequest},
        TContext
      > => {

      const mutationOptions = getReadinessSubmitCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    